import { createSlice } from "@reduxjs/toolkit";

interface HeaderState {
  title: string;
  openSearch: boolean;
  filtersApplied: boolean;
  openAllFilters: boolean;
  openActiveFilters: boolean;
  clearFilters: boolean;
  headerHeight: number;
  crumbs: any[];
}

export const headerSlice = createSlice({
    name: 'header',
    initialState: {
      title: "",
      openSearch: false,
      filtersApplied: false,
      openAllFilters: false,
      openActiveFilters: false,
      clearFilters: false,
      headerHeight: 0,
      crumbs: [],
    } as HeaderState,
    reducers: {
      setHeader: (state, action) => {
        state.title = action.payload;
      },
      setFiltersApplied: (state, action) => {
        state.filtersApplied = action.payload;
      },
      setFiltersCleared: (state, action) => {
        state.clearFilters = !state.clearFilters;
      },
      openSearch: (state, action) => {
        state.openSearch = !state.openSearch;
        state.openActiveFilters = false;
        state.openAllFilters = false;
      },
      openAllFilters: (state, action) => {
        state.openAllFilters = !state.openAllFilters;
        state.openSearch = false;
        state.openActiveFilters = false;
      },
      setBreadCrumbs: (state, action) => {
        console.log('setBreadCrumbs')
        state.crumbs = action.payload;
      },
      setHeaderHeight: (state, action) => {
        state.headerHeight = action.payload;
      },
    },
})

export const { setHeader, openSearch, openAllFilters, setFiltersApplied, setFiltersCleared, setBreadCrumbs, setHeaderHeight } = headerSlice.actions;

export default headerSlice.reducer;